export enum IntegrationPhoneNumberType {
  MOBILE = 'MOBILE',
  WORK = 'WORK',
  HOME = 'HOME',
}

export enum IntegrationEmailType {
  WORK = 'WORK',
  PERSONAL = 'PERSONAL',
}
